import type { Permission, User } from '@/types'

export function userHasPermission(user: User | null, permission: Permission): boolean {
  if (!user) return false
  const permissions = Array.isArray(user.permissions) ? user.permissions : []
  return permissions.includes('*') || permissions.includes(permission)
}

export function userHasAnyPermission(user: User | null, permissions: Permission[]): boolean {
  return permissions.some((permission) => userHasPermission(user, permission))
}
